<template>
  <div class="container">
    <van-tabs v-model="active" animated color="green">
      <van-tab
        v-for="item in tabList"
        :key="item.dictValue"
        :title="item.dictLabel"
      >
      </van-tab>
    </van-tabs>
    <div class="">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        v-if="list.length !== 0"
      >
        <div
          class="list"
          @click="toDetail(item)"
          v-for="item in list"
          :key="item.id"
        >
          <div class="head dis-flex flex-x-between">
            <div class="create-time">{{ item.createTime }}</div>
            <div class="state">
              {{
                dictionaryText(item.status, statusOption, {
                  label: 'dictLabel',
                  id: 'dictValue'
                })
              }}
            </div>
          </div>
          <div
            class="item dis-flex flex-x-between flex-y-center"
            v-for="detail in item.detailList"
            :key="detail.id"
          >
            <div class="left dis-flex">
              <img :src="detail.tradeCoverPhoto" alt="" />
              {{ detail.tradeName }}*{{ detail.amount }}
            </div>
            <div class="right">
              <img class="icon" src="@/assets/right-arrow.png" alt="" />
            </div>
          </div>

          <div class="price-btn dis-flex flex-x-between">
            <div class="price">总金额：{{ item.totalPrice }}</div>
            <div class="btn">订单详情</div>
          </div>
        </div>
      </van-list>
      <van-empty description="暂无订单" v-else />
    </div>
  </div>
</template>

<script>
import { getOrderList } from '@/api/good'
import { getDict } from '@/api/user/index'
export default {
  name: 'myOrders',
  data() {
    return {
      loading: false,
      finished: false,
      page: {
        currentPage: 1,
        pageSize: 10
      },
      list: [],
      active: 0,
      tabList: [
        { dictLabel: '全部', dictValue: '' },
        { dictLabel: '可付款', dictValue: '0' },
        // { dictLabel: '已完成', dictValue: '1' } //待核销
        { dictLabel: '已完成', dictValue: '1,3' } //待核销、已完成
      ],
      statusOption: [
        { dictLabel: '全部', dictValue: '' },
        { dictLabel: '可付款', dictValue: '0' },
        { dictLabel: '已完成', dictValue: '1' },
        { dictLabel: '已完成', dictValue: '3' },
        { dictLabel: '取消付款', dictValue: '9' }
      ]
    }
  },
  created() {
    this.getDict()
  },
  watch: {
    active: {
      handler() {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getDict() {
      getDict('cloud_mall_order_status').then((res) => {
        if (res.code === 200) {
          this.statusOption = res.data
          console.log(this.statusOption)
        }
      })
    },
    init() {
      this.page.currentPage = 1
      this.list = []
      this.finished = false
      this.onLoad()
    },
    onLoad(page = this.page) {
      this.loading = true
      const status = this.tabList[this.active].dictValue
      getOrderList(page.currentPage, page.pageSize, {
        // status: status === 'all' ? '' : status
        status: status
      }).then((res) => {
        const { rows = [] } = res
        if (this.page.currentPage == 1) {
          this.list = rows
        } else {
          this.list = [...this.list, ...rows]
        }
        this.page.currentPage++
        this.loading = false
        if (this.list.length >= res.total) {
          this.finished = true
        }
      })
    },
    toDetail(obj) {
      this.$router.push({
        name: 'orderDetail',
        query: { id: obj.id }
      })
      // console.log(this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  // height: calc(100vh - 88px) !important;

  .list {
    background: #fff;
    padding: 0 10px;
    margin-top: 15px;
    box-sizing: border-box;
    // box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    .head {
      font-size: 14px;
      padding: 10px 0;
      border-bottom: 1px solid #e8e8e8;
      .create-time {
        color: #7a7a7a;
      }
      .state {
        color: red;
      }
    }
    .item {
      border-bottom: 1px solid #e8e8e8;
      padding: 5px 0;
      .left {
        img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          margin-right: 5px;
        }
        font-size: 16px;
      }
      .right {
        .icon {
          width: 15px;
          height: 15px;
        }
      }
    }
    .price-btn {
      padding: 12px 0;
      .price {
        color: #7a7a7a;
        font-size: 17px;
      }
      .btn {
        padding: 5px 10px;
        background: red;
        color: #fff;
        font-size: 14px;
        border-radius: 3px;
      }
    }
  }
}
</style>
